<template>
	<article class="teaser teaser-vacancy">
		<div class="teaser-vacancy__inner">
			<div class="teaser-vacancy__body">
				<div class="teaser-vacancy__company-logo" v-if="company_logo">
					<img :src="company_logo" alt="Logo bedrijf" />
				</div>
				<h2 class="heading--4 teaser-vacancy__title">
					<a :href="link" class="teaser__title-link" :html="formattedTitle">{{
						formattedTitle
					}}</a>
				</h2>
				<div class="teaser-vacancy__text" v-html="excerpt"></div>

				<div class="teaser-vacancy__meta">
					<div class="teaser-vacancy__meta-location" v-if="location">
						<Icon name="marker" color="a" /> {{ location }}
					</div>
					<div class="teaser-vacancy__meta-salary" v-if="salary">
						<Icon name="euro" color="a" /> {{ salary | removeAfterComma }}
					</div>
					<div class="teaser-vacancy__meta-jobhours" v-if="jobHours">
						<Icon name="clock" color="a" /> {{ jobHours.replace(/;/g, ' of ') }}
					</div>
					<div class="teaser-vacancy__meta-date" v-if="date">
						{{ getDaysFrom(date) }} geleden geplaatst
					</div>
				</div>
			</div>
		</div>
	</article>
</template>
<script>
import { createDateFilter } from "vue-date-fns";
import { formatDistanceStrict } from "date-fns";
import locale from "date-fns/locale/nl";

import { store } from "./store.js";
import Icon from "./Icon.vue";

export default {
	name: "VacancyTeaser",
	props: [
		"title",
		"link",
		"excerpt",
		"date",
		"location",
		"salary",
		"jobHours",
		"company_logo",
	],
	filters: {
		date: createDateFilter("dd MMMM yyyy", { locale }),
		removeAfterComma(value) {
			if (!value) return "";

			// Remove everything after comma
			return value
				.split(" - ")
				.map((sal) => sal.split(",")[0])
				.join(" - ");
		},
	},
	data() {
		return {
			store,
		};
	},
	computed: {
		formattedTitle() {
			const parser = new DOMParser();
			const decodedTitle = parser.parseFromString(
				`<!doctype html><body>${this.title}`,
				"text/html"
			).body.textContent;
			return decodedTitle.replace("&amp;", "&");
		},
	},
	components: {
		Icon,
	},
	mounted: function () {
		//
	},
	methods: {
		getDaysFrom(date) {
			const now = new Date();
			const [day, month, year] = date.split("/");
			const formattedDate = new Date(year, month - 1, day);
			const distance = formatDistanceStrict(formattedDate, now, { locale });
			return distance;
		},
	},
};
</script>
